/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddLineItemModel
 */
export interface AddLineItemModel {
    /**
     * 
     * @type {string}
     * @memberof AddLineItemModel
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof AddLineItemModel
     */
    quantity?: number;
}

/**
 * Check if a given object implements the AddLineItemModel interface.
 */
export function instanceOfAddLineItemModel(value: object): boolean {
    return true;
}

export function AddLineItemModelFromJSON(json: any): AddLineItemModel {
    return AddLineItemModelFromJSONTyped(json, false);
}

export function AddLineItemModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddLineItemModel {
    if (json == null) {
        return json;
    }
    return {
        
        'sku': json['sku'] == null ? undefined : json['sku'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function AddLineItemModelToJSON(value?: AddLineItemModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sku': value['sku'],
        'quantity': value['quantity'],
    };
}

